import { FilterAdapter, useUrlFilterController } from 'app/components/filters/url-filters';
import { EventGroupByLabels, EventsGroupBy } from 'app/console-api/statistics/types';
import { AppsFiltersStyles } from 'app/components/common/common-styles';
import Select from 'react-select';

export const GroupByFilterAdapter: FilterAdapter<string> = {
  key: 'groupBy',
  fromUrl: (sp) => {
    const raw = sp.get('groupBy');
    if (!raw) return null;
    return raw;
  },
  toUrl: (sp, value) => {
    const next = new URLSearchParams(sp.toString());
    if (!value) {
      next.delete('groupBy');
    } else {
      next.set('groupBy', value);
    }
    return next;
  },
  toKey: (v) => `groupBy:${v || 'none'}`
};

export const GroupByFilter = ({ optionsList }: { optionsList: EventsGroupBy[] }) => {
  const ctl = useUrlFilterController();
  const value = ctl.get(GroupByFilterAdapter) || EventsGroupBy.EventType;
  const options = optionsList.map((groupBy) => ({
    label: EventGroupByLabels[groupBy],
    value: groupBy
  }));
  const selected = options.find((o) => o.value === value) ?? null;

  return (
    <Select
      isSearchable={false}
      styles={AppsFiltersStyles()}
      options={options}
      value={selected}
      placeholder={'Group by'}
      onChange={(opt: any) => ctl.set(GroupByFilterAdapter, opt?.value ?? null)}
    />
  );
};
